import axiosClient from "../../common/axios/axiosConfig";
import useQuery from "../../utils/useQuery";

export const getAllowParticipants = async (id: string) => {
  const urlSearchParams = useQuery();
  const telemedicineToken = urlSearchParams.get("token") || "";

  try {
    const response = await axiosClient.get(`/room/${id}/waiting`, {
      headers: {
        Authorization: `Bearer ${telemedicineToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Erro ao buscar participantes:", err);
    return null;
  }
};
